<template>
  <div>
    <div>
      <HeaderReceipt header="ดูรายละเอียดสินค้า" :img_header="header_image" link_back="stock/storage/mainstorage"/>
    </div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-else>
      <v-slide-x-reverse-transition>
        <v-alert type="success" class="alert" v-if="alert_success === true">ย้ายสินค้าสำเร็จ !</v-alert>
      </v-slide-x-reverse-transition>
      <v-card elevation="10">
        <div class="pa-4">
          <HeaderDetails :name="item_name" :total="total" :type="unit_main"/>
          <v-card-title>
            <v-text-field v-model="search" color="#86bc3a" append-icon="mdi-magnify" label="ค้นหา" single-line hide-details></v-text-field>
          </v-card-title>
          <v-data-table :headers="details_headers" :items="item_lots" :footer-props="footer_Props" :search="search" mobile-breakpoint="0">
            <template v-slot:item="dataDetail">
              <tr>
                <td>
                  <a @click="redirect_page(dataDetail.item.lot_no, dataDetail.item.date_expired, dataDetail.item.product_id)">{{ dataDetail.item.lot_no }}</a>
                  <div class="none">{{ item_name = dataDetail.item.product_name }}</div>
                </td>
                <td>{{ dataDetail.item.date_expired }}</td>
                <td>{{ format_number(dataDetail.item.quantity) }}</td>
                <td>{{ item_unit = unit_main }}</td>
                <td>{{ dataDetail.item.supplier }}</td>
                <td><v-btn @click="get_moveStock(dataDetail.item.quantity, dataDetail.item.warehouse_id, dataDetail.item.product_id, dataDetail.item.lot_no, dataDetail.item.choices)" class="pa-6 ma-2 grad-success-bg white--text"><v-icon>mdi-arrow-up-left</v-icon> ย้ายคลัง</v-btn></td>
              </tr>
            </template>
          </v-data-table>
        </div>
        <v-dialog v-model="move_stock" persistent max-width="650">
          <v-card>
            <v-form ref="add_form" @submit.prevent="send_data">
              <v-card-title>
                การย้ายคลัง (คงเหลือ {{ move_storage.quantity_get }} {{ item_unit }})
              </v-card-title>

              <v-card-text>
                <div class="mb-6">
                  <div class="d-flex">
                    <v-icon>mdi-document</v-icon>
                    <div class="ml-1">คลังที่ต้องการย้าย</div>
                  </div>
                  <div class="grid_full">
                    <div class="mt-3 mr-1">
                      <v-select color="#86bc3a" :items="items_in" item-text="name" item-value="id" label="กรุณาเลือกคลังที่ต้องการย้าย" :rules="[v => !!v || 'กรุณาเลือกคลังที่ต้องการย้าย']" v-model="move_storage.stock_select" hide-details="auto" outlined></v-select>
                    </div>
                  </div>
                </div>
                <div class="mb-6">
                  <div class="d-flex">
                    <v-icon>mdi-document</v-icon>
                    <div class="ml-1">จำนวนสินค้า</div>
                  </div>
                  <div class="grid_full">
                    <div class="mt-3 mr-1">
                      <v-text-field color="#86bc3a" type="number" label="กรุณากรอกจำนวนสินค้า" hide-details="auto" @keypress="onlyNumber($event)" :rules="[v => !!v || 'กรุณากรอกจำนวนสินค้า']" required v-model="move_storage.qty" outlined></v-text-field>
                    </div>
                  </div>
                </div>
                <div>
                  <div class="d-flex">
                    <v-icon>mdi-document</v-icon>
                    <div class="ml-1">สาเหตุการย้ายคลัง</div>
                  </div>
                  <div class="grid_full">
                    <div class="mt-3 mr-1">
                      <v-textarea color="#86bc3a" outlined label="กรุณากรอกสาเหตุการย้ายคลัง" :rules="[v => !!v || 'กรุณากรอกสาเหตุการย้ายคลัง']" hide-details="auto" v-model="move_storage.cause_note"></v-textarea>
                    </div>
                  </div>
                </div>
              </v-card-text>
              <v-spacer></v-spacer>
              <div class="text-center pa-4">
                <v-btn large class="grad-success-bg white--text mr-3" :disabled="disabled_btn" type="submit" style="font-size: 18px">
                  บันทึก
                </v-btn>
                <v-btn large class="grad-danger-bg white--text" type="button" style="font-size: 18px" @click="move_stock = false">
                  ยกเลิก
                </v-btn>
              </div>
            </v-form>
          </v-card>
        </v-dialog>
      </v-card>
    </div>
    <v-overlay :value="loading_redirect" class="z_index">
      <div class="text-center">
        <v-progress-circular indeterminate size="70" width="7" color="#86bc3a"></v-progress-circular>
        <div class="mt-4">กำลังค้นหาข้อมูลล็อตสินค้า...</div>
      </div>
    </v-overlay>
  </div>
</template>

<script>
import HeaderDetails from "../menustorage/HeaderDetails.vue";
import {HTTP} from "@/axios";
import HeaderReceipt from "@/components/admin/stock/menustorage/HeaderReceipt";
import HeaderImage from "@/assets/loupe.png";
import Swal from "sweetalert2";
import {diffChangeFormat, diffDateTH, formatNumber, onlyForNumber} from "@/js/handler";

export default {
  inject: {
    theme: {
      default: {
        isDark: false
      },
    },
  },
  name: "StorageDetails",
  components: {
    HeaderReceipt,
    HeaderDetails,
  },
  data(){
    return {
      header_image: HeaderImage,
      loading_page: false,
      loading_redirect: false,
      search: null,
      move_stock: false,
      alert_success: false,
      disabled_btn: false,
      name: null,
      items_in: null,
      unit_main: null,
      move_storage: {
        stock_select: null,
        qty: 1,
        cause_note: null,
        warehouse_id: null,
        product_id: null,
        lot_no: null,
        quantity_get: null,
      },
      footer_Props: {
        // showFirstLastPage: true,
        // firstIcon: 'mdi-arrow-collapse-left',
        // lastIcon: 'mdi-arrow-collapse-right',
        // prevIcon: 'mdi-minus',
        // nextIcon: 'mdi-plus',
        'items-per-page-text':'รายการต่อหน้า'
      },
      details_headers: [
        {
          text: 'ล็อตสินค้า',
          align: 'start',
          value: 'lot_no',
          fixed: true,
          width: '130px',
        },
        {
          text: 'วันหมดอายุ',
          value: 'date_expired',
          fixed: true,
          width: '140px',
        },
        {
          text: 'จำนวนคงเหลือ',
          value: 'quantity',
          fixed: true,
          width: '160px',
        },
        {
          text: 'หน่วยนับ',
          value: 'unit',
          sortable: false,
          fixed: true,
          width: '150px',
        },
        {
          text: 'ซัพพลายเออร์',
          value: 'supplier',
          fixed: true,
          width: '300px',
        },
        {
          text: 'จัดการ',
          value: '',
          sortable: false,
          fixed: true,
          width: '100px',
        },
      ],
      items: [
        {id: 1, name: 'คลังรอคืน'},
        {id: 2, name: 'คลังชำรุด'},
      ],
      item_lots: [],
      item_unit: null,
      item_name: null,
    }
  },
  methods: {
    onlyNumber: function(evt) {
      return onlyForNumber(evt)
    },
    format_number: function(value) {
      return formatNumber(value)
    },
    diffChange: function (value) {
      return diffChangeFormat(value)
    },
    diffTH: function(value) {
      return diffDateTH(value)
    },
    getProduct_lots(){
      const pro_id = this.$route.params.id;
      this.loading_page = true
      HTTP.post('/inventory/getmainproduct', {
        product_id: pro_id,
        warehouse: 0,
      }).then((res) => {
        if (res.data.success === true){
          this.loading_page = false
          this.item_lots = res.data.object.products
          this.unit_main = res.data.object.unit_main
        }
      })
    },
    get_moveStock(quantity, warehouse_id, product_id, lot_no, items_in) {
      this.move_stock = true
      this.move_storage.quantity_get = quantity
      this.move_storage.warehouse_id = warehouse_id
      this.move_storage.product_id = product_id
      this.move_storage.lot_no = lot_no
      this.items_in = items_in
    },
    redirect_page(lots_number, date_expired, product_id) {
      // แสดง loading
      this.loading_redirect = true
      
      // หา id จาก lot_no และ product_id
      HTTP.post('/stocks/alllots')
        .then((res) => {
          if (res.data.success === true) {
            const lot_item = res.data.object.find((item) => 
              item.lot_no === lots_number && item.product_id === product_id
            )
            if (lot_item && lot_item.id) {
              const url = `/stock/history/searchProductLotsDetail?id=${lot_item.id}&lot_no=${lots_number}&product_id=${product_id}`
              window.open(url, '_blank')
            } else {
              Swal.fire({
                text: 'ไม่พบข้อมูลล็อตสินค้า',
                icon: 'error',
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonText: `ตกลง`,
      })
            }
          } else {
            Swal.fire({
              text: 'ไม่สามารถค้นหาข้อมูลได้',
              icon: 'error',
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: `ตกลง`,
            })
          }
        })
        .catch(() => {
          Swal.fire({
            text: 'เกิดข้อผิดพลาดในการค้นหาข้อมูล',
            icon: 'error',
            showDenyButton: false,
            showCancelButton: false,
            confirmButtonText: `ตกลง`,
          })
        })
        .finally(() => {
          this.loading_redirect = false
        })
    },
    send_data() {
      if (this.$refs.add_form.validate()) {
        if (this.move_storage.qty > 0) {
          HTTP.post('/inventory/movestorage', {
            user_create: this.$store.state.userDetail.id,
            user_name: this.$store.state.userDetail.name,
            from_warehouse: 'คลังหลัก',
            warehouse_id: this.move_storage.warehouse_id,
            product_id: this.move_storage.product_id,
            lot_no: this.move_storage.lot_no,
            stock_move_id: this.move_storage.stock_select,
            qty: this.move_storage.qty,
            cause_note: this.move_storage.cause_note,
          }).then((res) => {
            if (res.data.success === true) {
              this.move_stock = false
              this.alert_success = true
              this.move_storage.stock_select = null
              this.move_storage.qty = null
              this.move_storage.cause_note = null
              setTimeout(() => this.alert_success = false, 3000)
              setTimeout(() => this.getProduct_lots(), 1000)
            }
            else if (res.data.success === false) {
              Swal.fire({
                text: res.data.message,
                icon: 'error',
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonText: `ตกลง`,
                denyButtonText: `ยกเลิก`,
              }).then(() => {
                this.move_storage.qty = null
              })
            }
          })
        }
        else {
          Swal.fire({
            text: 'จำนวนสินค้าที่ต้องการย้ายต้องมาก 0 !',
            icon: 'error',
            showDenyButton: false,
            showCancelButton: false,
            confirmButtonText: `ตกลง`,
            denyButtonText: `ยกเลิก`,
          }).then(() => {
            this.move_storage.qty = null
          })
        }
      }
    }
  },
  computed: {
    total() {
      let data_list = this.item_lots
      let total_set = 0
      data_list.forEach((data) => {
        if (data.total_set !== '' && data.total_set !== null) {
          total_set += parseInt(data.quantity)
        }
        else {
          data.quantity = 0
        }
      })
      return total_set
    }
  },
  mounted() {
    this.getProduct_lots();
  }
}
</script>

<style scoped>
.alert {
  margin: 0;
  position: fixed !important;
  z-index: 9999;
  top: 15px;
  right: 5px;
}
.none {
  display: none;
}
.img_title_header{
  width: 50px;
}

.img_title_header > img{
  max-width: 100%;
}
.grid_full {
  display: grid;
  grid-template-columns: 100%;
}
.grid_unit {
  display: grid;
  grid-template-columns: 50% 50%;
}
.z_index {
  z-index: 9999;
}
</style>
